import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { InfoIconToolTip } from '../../UI/InfoIconToolTip/InfoIconToolTip';
import LineChartSkeleton from './LineChartSkeleton';
import LineChartNoData from './LineChartNoData';

import Styles from './styles.module.scss';
import './highcharts-tooltip.css';

export interface ILineChartWidget {
    config: {}; //Highcharts configurations options. https://api.highcharts.com/highcharts/
    data?: any[];
    loading?: boolean;
    noDataText: string;
    title?: JSX.Element | string;
    seriesName?: string;
    seriesRounding?: number;
}

const LineChartWidget = (props: ILineChartWidget) => {
    return (
        <div className={Styles.Widget}>
            <div className={Styles.ChartTitleWrapper}>
                {props.title}
                <InfoIconToolTip infoMessage={'misc.Analytics.TodayRushTimeTooltip'} />
            </div>
            {!props.data || props.loading ? (
                <div>{props.loading ? <LineChartSkeleton /> : <LineChartNoData text={props.noDataText} />}</div>
            ) : (
                <div className={Styles.ChartWrapper}>
                    <div>
                        <HighchartsReact
                            containerProps={{ style: { height: '100%' } }}
                            highcharts={Highcharts}
                            options={{
                                ...props.config,
                                series: [
                                    {
                                        data: props.data,
                                        name: props.seriesName,
                                        rounding: props.seriesRounding,
                                    },
                                ],
                            }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default LineChartWidget;
